import { render, staticRenderFns } from "./HomePic.vue?vue&type=template&id=1c4c1ac1&scoped=true&"
import script from "./HomePic.vue?vue&type=script&lang=js&"
export * from "./HomePic.vue?vue&type=script&lang=js&"
import style0 from "./HomePic.vue?vue&type=style&index=0&id=1c4c1ac1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c1ac1",
  null
  
)

export default component.exports